// LockScreen.jsx
import React, { useState, useEffect } from "react";
import "./LockScreen.css";
import { useLanguage } from "../../LanguageProvider";
import Services from "../../services/Services";
import { useToaster } from "../../ToasterProvider";
import { TbUser } from "react-icons/tb";

const Lockscreen = ({ onClose }) => {
  const { toastError } = useToaster();
  const { getTranslation } = useLanguage();

  const [avatar, setAvatar] = useState("");
  const [password, setPassword] = useState("");
  const [userName, setUserName] = useState("");
  const [email, setEmail] = useState("");
  const [token, setToken] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const sessionUser = JSON.parse(sessionStorage.getItem("user"));
    const localUser = JSON.parse(localStorage.getItem("user"));

    if (sessionUser) {
      setUserName(`${sessionUser.name} ${sessionUser.lastname}`);
      setEmail(sessionUser.email);
    } else if (localUser) {
      setUserName(`${localUser.name} ${localUser.lastname}`);
      setEmail(localUser.email);
    } else {
      setUserName("User");
    }

    const sessionToken = sessionStorage.getItem("token");
    const localToken = localStorage.getItem("token");
    setToken(localToken || sessionToken || "");
  }, []);

  const handleUnlock = async () => {
    if (isLoading) return; // tekrar tıklamayı blokla
    setIsLoading(true);
    try {
      const res = await Services.UserLogin(token, email, password);
      if (res?.data?.status) {
        localStorage.setItem("isLocked", "false");
        onClose();
      } else {
        toastError(getTranslation("wrongPassword"));
      }
    } catch (err) {
      toastError(getTranslation("somethingWentWrong"));
    } finally {
      setIsLoading(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !isLoading) {
      handleUnlock();
    }
  };

  useEffect(() => {
    try {
      const sessionUserString = sessionStorage.getItem("user");
      const localUserString = localStorage.getItem("user");

      let userData = null;
      if (sessionUserString) {
        userData = JSON.parse(sessionUserString);
      } else if (localUserString) {
        userData = JSON.parse(localUserString);
      }

      if (userData) {
        if (userData.userAvatar) {
          setAvatar(userData.userAvatar);
        }
      }
    } catch (error) {
      console.error("Error parsing user data:", error);
    }
  }, []);

  return (
    <div className="lockscreen-overlay">
      <div
        className={`lockscreen-content ${isLoading ? "loading" : ""}`}
        aria-busy={isLoading}
      >

        <div
          className="avatar-display"
          style={{
            backgroundImage: avatar ? `url(${avatar})` : "none",
          }}
        >
          {!avatar && (
            <TbUser
              size={40}
              style={{
                margin: "auto",
                display: "flex",
                color: "#aaa",
                alignSelf: "center",
              }}
            />
          )}
        </div>
        <span className="name-label">{userName}</span>

        <input
          type="text"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder={getTranslation("password")}
          className="lockscreen-input masked"
          onKeyDown={handleKeyDown}
          disabled={isLoading}
          autoFocus
        />

        <button
          onClick={handleUnlock}
          className={`lockscreen-button ${isLoading ? "is-loading" : ""}`}
          disabled={isLoading || !password}
        >
          {isLoading ? (
            <>
              <span className="spinner" aria-hidden="true" />
            </>
          ) : (
            <span className="btn-label">{getTranslation("unlock")}</span>
          )}
        </button>
      </div>
    </div>
  );
};

export default Lockscreen;